import { render, staticRenderFns } from "./TaskRestored.vue?vue&type=template&id=abc55262&scoped=true"
import script from "./TaskRestored.vue?vue&type=script&lang=js"
export * from "./TaskRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc55262",
  null
  
)

export default component.exports